import { TZ } from './constants.ts'

const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' })

/** Calendar day in WIB as `YYYY-MM-DD`. Server decides "today"; never trust the client clock. */
export function wibDate(d: Date = new Date()): string {
  return fmt.format(d)
}

/** Add whole days to a `YYYY-MM-DD` string (pure calendar math, DST-free). */
export function addDays(ymd: string, n: number): string {
  const [y, m, d] = ymd.split('-').map(Number) as [number, number, number]
  const t = new Date(Date.UTC(y, m - 1, d + n))
  return t.toISOString().slice(0, 10)
}
